import DepartamentoService from 'src/modules/departamento/departamentoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'DEPARTAMENTO_FORM';

const departamentoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: departamentoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await DepartamentoService.find(id);
      }

      dispatch({
        type: departamentoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: departamentoFormActions.INIT_ERROR,
      });

      getHistory().push('/departamento');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: departamentoFormActions.CREATE_STARTED,
      });

      await DepartamentoService.create(values);

      dispatch({
        type: departamentoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.departamento.create.success'),
      );

      getHistory().push('/departamento');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: departamentoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: departamentoFormActions.UPDATE_STARTED,
      });

      await DepartamentoService.update(id, values);

      dispatch({
        type: departamentoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.departamento.update.success'),
      );

      getHistory().push('/departamento');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: departamentoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default departamentoFormActions;
